import api from './api'

/** 可由 AI 随机生成的新建小说字段。 */
export type NovelCreationGenerateField = 'title' | 'description'

export interface NovelCreationGenerateRequest {
  field: NovelCreationGenerateField
  /** 关键词，留空则完全随机 */
  keyword?: string
  /** 当前已填的标题（作为参考） */
  currentTitle?: string
  /** 当前已填的构思（作为参考） */
  currentDescription?: string
  /** 指定模型（可选） */
  modelId?: string
}

export interface NovelCreationGenerateData {
  field: string
  value: string
  keyword: string
}

export interface NovelCreationGenerateResponse {
  success: boolean
  message?: string
  data: NovelCreationGenerateData
}

/**
 * 新建小说创作助手：调用后端随机生成作品名称 / 构思。
 * 对应后端 POST /api/generate-novel-creation-field。
 */
export const novelCreationAssistantService = {
  async generateField(
    payload: NovelCreationGenerateRequest,
  ): Promise<NovelCreationGenerateResponse> {
    return (await api.post(
      '/generate-novel-creation-field',
      payload,
    )) as unknown as NovelCreationGenerateResponse
  },
}
